import type { TreeItem, Tree } from "../types";
import snakeToPascal from "../../../tools";

export const isMatchSearchString = (
  item: TreeItem,
  tree: Tree,
  searchString: string,
): boolean => {
  if (
    item.name.toLowerCase().includes(searchString.toLowerCase()) ||
    (searchString.startsWith("#") && searchString.slice(1) === item.id) ||
    item.type.toLowerCase().includes(searchString.toLowerCase())
  ) {
    return true;
  }

  let match = false;
  if (item.fields) {
    Object.entries(item.fields).forEach(([key, field]) => {
      if (
        !field.hide &&
        snakeToPascal(key).toLowerCase().includes(searchString.toLowerCase())
      ) {
        match = true;
      }
    });
  }

  return (
    match ||
    (item.childrens &&
      item.childrens.some(
        (id) =>
          tree.items[id] &&
          isMatchSearchString(tree.items[id], tree, searchString),
      ))
  );
};

export const hasComputeErrors = (item: TreeItem, tree: Tree): boolean => {
  if (!item) return false;
  return (
    !!item.compute_error ||
    (!!item.fields &&
      Object.values(item.fields).some(
        (field) => !field.hide && !!field.compute_error,
      )) ||
    (!!item.childrens &&
      item.childrens.some(
        (id) => tree.items[id] && hasComputeErrors(tree.items[id], tree),
      ))
  );
};
